var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("el-row", [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-radio", {
    attrs: {
      label: 1,
      border: ""
    },
    model: {
      value: _vm.media,
      callback: function callback($$v) {
        _vm.media = $$v;
      },
      expression: "media"
    }
  }, [_vm._v("图片")]), _c("el-radio", {
    attrs: {
      label: 2,
      border: ""
    },
    model: {
      value: _vm.media,
      callback: function callback($$v) {
        _vm.media = $$v;
      },
      expression: "media"
    }
  }, [_vm._v("视频")])], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-button", {
    staticStyle: {
      float: "right"
    },
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: _vm.updateConfig
    }
  }, [_vm._v("保存")])], 1)], 1), _c("div", {
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary",
      plain: ""
    },
    on: {
      click: _vm.bannerImage
    }
  }, [_vm._v("图片管理")]), _c("el-button", {
    attrs: {
      type: "primary",
      plain: ""
    },
    on: {
      click: _vm.bannerVideo
    }
  }, [_vm._v("视频管理")])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };